<template>
  <div v-if="isLoading" class="row">
    <div class="col">
      <FontAwesomeIcon icon="fa-solid fa-spinner" spin />
      <span class="ms-2">analyzing...</span>
    </div>
  </div>
  <div v-else class="custom-header">
    <div class="row mt-2">
      <div class="col-4">
        <span class="custom-label">Vendor:</span>
        <span class="ms-2 custom-blue">{{ VendorName }}</span>
      </div>
      <div class="col-2 custom-invoice" :class="{ 'custom-invoice-captured': isCopied('invoiceid') }">
        <span class="custom-label">Invoice #:</span>
        <a href="#" @click.prevent="copy('invoiceid', InvoiceId)" class="ms-2">
          <FontAwesomeIcon icon="fas fa-clipboard custom-clipboard" />
        </a>
        <span class="ms-2 me-2 custom-invoice-number">{{ InvoiceId }}</span>
        <FontAwesomeIcon v-if="isCopied('invoiceid')" icon="fas fa-check-circle" :style="{ color: 'green' }" />
      </div>
      <div class="col-2">
        <span class="custom-label">Date:</span>
        <span class="ms-2">{{ InvoiceDate }}</span>
      </div>
      <div class="col-2 custom-invoice" :class="{ 'custom-total-match': isTotalMatch }">
        <span class="custom-label">Total:</span>
        <a href="#" @click.prevent="copy('invoiceTotal', InvoiceTotal)" class="ms-2 me-1">
          <FontAwesomeIcon icon="fas fa-clipboard custom-clipboard" />
        </a>
        <FontAwesomeIcon v-if="isCopied('invoiceTotal')" icon="fas fa-check-circle" :style="{ color: 'green' }" />
        <span class="ms-2 me-1">{{ InvoiceTotal }} (so far: {{ totalSoFar }})</span>
        <FontAwesomeIcon v-if="isTotalMatch" icon="fas fa-check-circle" :style="{ color: 'green' }" />
      </div>
      <div class="col">
        <button class="btn btn-primary btn-sm" @click="clearChecks">Clear Checks</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { invoiceStore } from '@/stores/invoice'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import globals from '@/plugins/globals'
export default {
  name: 'InvoiceHeader',
  components: {
    FontAwesomeIcon
  },
  props: {
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentStatus: null,
      copiedCells: new Set()
    }
  },
  computed: {
    ...mapState(invoiceStore, ['loading', 'invoice', 'invoiceDocs', 'selectedCells']),
    isLoading() {
      let _is = false
      if (this.loading) {
        if (this.loading.analysis || this.loading.invoice) {
          _is = true
        }
      }
      return _is
    },
    VendorName() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.VendorName ? this.invoiceDocs[0].Fields.VendorName.Content : ''
        }
      }
      return _data
    },
    InvoiceId() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.InvoiceId ? this.invoiceDocs[0].Fields.InvoiceId.Content : ''
        }
      }
      return _data
    },
    InvoiceDate() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.InvoiceDate ? this.invoiceDocs[0].Fields.InvoiceDate.Content : ''
        }
      }
      return _data
    },
    PurchaseOrder() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.PurchaseOrder ? this.invoiceDocs[0].Fields.PurchaseOrder.Content : ''
        }
      }
      return _data
    },
    InvoiceTotal() {
      let _data = ''
      if (this.invoiceDocs) {
        if (this.invoiceDocs.length > 0) {
          _data = this.invoiceDocs[0].Fields.InvoiceTotal ? this.invoiceDocs[0].Fields.InvoiceTotal.Content : ''
        }
      }
      return _data
    },
    totalSoFar() {
      let _total = 0
      if (this.selectedCells) {
        this.selectedCells.forEach((element) => {
          if (element.data) {
            let amount = element.data.replace(/[$,]/g, '')
            if (globals.isNumeric(amount)) {
              _total += parseFloat(amount)
            }
          }
        })
      }
      // console.log('Total So Far', {
      //   invoiceTotal: this.InvoiceTotal,
      //   calcTotal: _total
      // })
      return parseFloat(_total.toFixed(2))
    },
    isTotalMatch() {
      let _is = false
      let _invoiceTotal = parseFloat(this.InvoiceTotal.replace(/[$,]/g, ''))
      _invoiceTotal = Math.round(_invoiceTotal * 100) / 100
      let _roundedTotalSoFar = Math.round(this.totalSoFar * 100) / 100
      console.log('isTotalMatch', {
        InvoiceTotal: this.InvoiceTotal,
        invoiceTotal: _invoiceTotal,
        totalSoFar: _roundedTotalSoFar
      })
      if (_invoiceTotal === _roundedTotalSoFar) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions(invoiceStore, ['setInvoice', 'saveStatus', 'resetCells']),
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    clearChecks() {
      this.resetCells()
    },
    extractNumber(str) {
      const match = str.match(/[\d,.]+/)
      return match ? parseFloat(match[0].replace(/,/g, '')) : null
    },
    copy(item, content) {
      if (item === 'invoiceTotal') {
        content = this.extractNumber(content)
      }
      console.log('Copying:', { item, content })
      navigator.clipboard
        .writeText(content)
        .then(() => {
          // Mark the cell as copied
          this.copiedCells.add(item)
        })
        .catch((err) => console.error('Clipboard copy failed:', err))
    },
    isCopied(item) {
      return this.copiedCells.has(item)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 5px;
}
.custom-label {
  font-weight: 500;
}
.custom-invoice-number {
  font-size: 1.2em;
  font-weight: 500;
}
.custom-invoice-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 62vh;
  padding-right: 5px;
}
.custom-status {
  display: inline-flex;
}
.custom-select {
  width: 150px;
  margin-left: 10px;
}
.custom-clipboard-copied {
  color: green !important;
}
.custom-blue {
  color: rgb(33, 33, 255);
  font-weight: 500;
  font-size: 1.1em;
}
.custom-invoice {
  border: 1px solid #ff0000;
  padding: 5px;
}
.custom-list {
  list-style-type: none;
  padding: 0;
}
.custom-total {
  border-top: 1px solid #dee2e6;
}
.custom-number {
  float: right;
}
.custom-total-match {
  border: 1px solid green;
}
.custom-invoice-captured {
  border: 1px solid green;
}
</style>
